import { inject } from '@angular/core';
import { Observable } from 'rxjs';
import { VersionService } from '../services/version.service';
import { NavController, Platform } from '@ionic/angular';
import { take, map, filter } from 'rxjs/operators';

export function VersionGuard(): Observable<boolean> | Promise<boolean> | boolean {
  const versionService = inject(VersionService);
  const navController = inject(NavController);
  const platform = inject(Platform);

  const isRunningOnMobileDevice = (): boolean => {
    return platform.is('cordova');
  };

  if (!isRunningOnMobileDevice()) {
    return true;
  }

  return versionService.versionIsValid$.pipe(
    filter(isValid => isValid !== null),
    take(1),
    map(isValid => {
      if (!isValid) {
        navController.navigateRoot('update-needed');
        return false;
      }
      return true;
    })
  );
}
